<template>
    <div>
        <base-header type="gradient-success" class="pb-6">
        </base-header>
        <ShowDealers/>

    </div>
</template>

<script>
    import ShowDealers from "../../components/Dealers/ShowDealers";
    import {dealers_service} from "../../services/dealers/DealersService";

    export default {
        name: "index",
        components: {ShowDealers},
        created() {
            dealers_service.GetAllDealers()
        }
    }
</script>

<style scoped>

</style>